import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';

import TicketCategories from '../ticketMgmtPortal/manage-ticket-types/TicketCategories';
import { configs } from '@constants/configs/configs';
import { getHistory } from '@reducers/appReducer';

const TicketTypesManager = (props) => {
    const {
        router: {
            location: {
                pathname
            }
        }
    } = props;
    return (
        pathname === configs.routes.TICKET_MGMT_TYPES ?
            <div id='ticketTypes'>
                <TicketCategories/>
            </div> : <Outlet />
    );
};

const mapStateToProps = state => ({
    router: getHistory(state)
});

export default connect(mapStateToProps)(TicketTypesManager);